define('viewmodels/Weightings_Thresholds/AMLThresholds',['knockout', 'plugins/router', 'services/appsecurity', 'services/navigation', 'durandal/app', 'services/logger', 'durandal/system', 'viewmodels/GeneralSettings'], function (ko, router, appsecurity, navigation, app, logger, system, ObjGeneralSettings) {
    var title = 'RiskLevel';

    var AtViewModel = {
        activate: activate,
        title: title,
        attached: attached,
        detached: detached,
        appsecurity: appsecurity,
        ObjGeneralSettings: ObjGeneralSettings,
        AssessmentType: ko.observable("AML"),
        RiskAreaListTh: ko.observableArray(),
        RiskAreaTabClickTh: RiskAreaTabClickTh,
        OverallTabClick: OverallTabClick,
        RiskFactorTabClickTh: RiskFactorTabClickTh,
        RiskFactorListTh: ko.observableArray(),
        ClickedRiskAreaId: ko.observable(),
        ClickedRiskAreaType: ko.observable(),
        ClickedRiskAreaName: ko.observable(),
        ClickedRiskFactorId: ko.observable(),
        ClickedRiskFactorName: ko.observable(),
        ClickedRAType: ko.observable(),
        ThresholdValuesList: ko.observableArray(),
        ThresholdValuesListDup: ko.observableArray(),
        ThresholdChildList: ko.observableArray(),
        SelectedAssessmentId: ko.observable(),
        SelectedSurveyComponentIdTh: ko.observable(),
        ThresholdCellBlur: ThresholdCellBlur,
        ResetThresholdData: ResetThresholdData,
        SaveThresholdBtnClick: SaveThresholdBtnClick,
        GreyOutCells: GreyOutCells,
        SaveQualitativeThresholdValues: SaveQualitativeThresholdValues,
        ResetQualitativeThresholdValues: ResetQualitativeThresholdValues,
        countEntry: ko.observable(0),
        ErrorStatus: ko.observable(0),
        PrevRAId: ko.observable(),
        QualThresholdValuesList: ko.observableArray(),
        QualThresholdValuesListDup: ko.observableArray([]),
        OverallThresholdValuesList: ko.observableArray([]),
        OverallThresholdValuesListDup: ko.observableArray([]),
        FactorCountEntry: ko.observable(0),
        PrevFactorId: ko.observable(),
        onBlurMin: onBlurMin,
        InputChange: InputChange,
        InputChangeEvent: ko.observable(false),
        SaveButtonClick: ko.observable(false),
        onBlurEvent: onBlurEvent,
        onKeyPressvalidateNumber: onKeyPressvalidateNumber,
        AssessmentTypeList: ko.observable(),
        ScreenName: ko.observable(),
        AssessmentTypeId: ko.observable(),
        SurveyCategoryListTh: ko.observableArray([]),
        SurveyCategoryTabClickTh: SurveyCategoryTabClickTh,
        ComposeBindingFlag: ko.observable(false),
        invokepage: invokepage,
        AreaLeveljstree: ko.observableArray([]),
        ToggleNavigationMenu2: ToggleNavigationMenu2,
        CollapseAllTreeView: CollapseAllTreeView,
        ExpandAllTreeView: ExpandAllTreeView,
        SurveyTypeClicked: ko.observable(),
        SelectedSurveyComponentId: ko.observable(),
        Type: ko.observable(),
        AreaType: ko.observable(),
        copyToAll: copyToAll,
        ControlsAccess: ko.observable(false),
        copyToAllFlag: ko.observable(0),
        RA_Type: ko.observable(),
        LocaleCheckFlag: ko.observable(false),
        hasChildNodes: ko.observable(false)
    };

    return AtViewModel;

    function activate() {
        try {
            if (AtViewModel.ObjGeneralSettings === undefined || AtViewModel.ObjGeneralSettings.LocalizedTextList() === undefined || ((AtViewModel.ObjGeneralSettings.LocalizedTextList() !== undefined || AtViewModel.ObjGeneralSettings.LocalizedTextList() !== null) && AtViewModel.ObjGeneralSettings.LocalizedTextList().length === 0)) {
                AtViewModel.ObjGeneralSettings.GetLocalizedData().then(function () {
                    if (AtViewModel.ObjGeneralSettings.LocalizedTextList() == undefined || AtViewModel.ObjGeneralSettings.LocalizedTextList() == null || AtViewModel.ObjGeneralSettings.LocalizedTextList().length <= 0 || AtViewModel.ObjGeneralSettings.LocalizedIndexList() == undefined || AtViewModel.ObjGeneralSettings.LocalizedIndexList() == null)
                        AtViewModel.LocaleCheckFlag(false);
                    else
                        AtViewModel.LocaleCheckFlag(true);
                });
            }
            else {
                if (AtViewModel.ObjGeneralSettings.LocalizedTextList() == undefined || AtViewModel.ObjGeneralSettings.LocalizedTextList() == null || AtViewModel.ObjGeneralSettings.LocalizedTextList().length <= 0 || AtViewModel.ObjGeneralSettings.LocalizedIndexList() == undefined || AtViewModel.ObjGeneralSettings.LocalizedIndexList() == null)
                    AtViewModel.LocaleCheckFlag(false);
                else
                    AtViewModel.LocaleCheckFlag(true);
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: activate() method in AMLThresholds.js';
            logger.logMessage(msg);
        }
    };
    function detached() {
        try {
            $($(document.getElementsByClassName('list-group-item')).get(4)).removeClass('active');
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: detached() method in AMLThresholds.js';
            logger.logMessage(msg);
        }
    }

    function attached() {
        try {
            var Id = AtViewModel.appsecurity.getParameterByName('atype');
            AtViewModel.AssessmentTypeId(Id);
            AtViewModel.appsecurity.GetAssessmentNames().then(function () {
                AtViewModel.AssessmentType(AtViewModel.appsecurity.GetAssessmentName(AtViewModel.AssessmentTypeId()))
                AtViewModel.ScreenName(AtViewModel.AssessmentType() + ' ' + ((!AtViewModel.LocaleCheckFlag() || AtViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('InherentThresholdsHeading') == -1) ? 'Inherent Risk Thresholds' : AtViewModel.ObjGeneralSettings.LocalizedTextList()[AtViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('InherentThresholdsHeading')].Name()));
            });
            AtViewModel.SelectedAssessmentId(Id);
            if (appsecurity.isConfigurationFreeze() === undefined) {
                appsecurity.GetConfigurationFreezeFlag().then(function () {
                    if (appsecurity.WriteAccess() == true && !appsecurity.isConfigurationFreeze()) {
                        AtViewModel.ControlsAccess(true);
                    }
                    else {
                        AtViewModel.ControlsAccess(false);
                    }
                });
            }
            else if (appsecurity.WriteAccess() == true && !appsecurity.isConfigurationFreeze()) {
                AtViewModel.ControlsAccess(true);
            }
            else {
                AtViewModel.ControlsAccess(false);
            }

            var parent = $(location).attr('href').split('/').pop();

            if (parent.split('?')[0] == 'AMLThresholds') {
                AtViewModel.ComposeBindingFlag(false);
                invokepage();
            } else {
                $("#btnSaveThreshold").hide();
                $("#btnCancelThreshold").hide();
                $("#btnSaveThreshold1").hide();
                $("#btnCancelThreshold1").hide();
                AtViewModel.ComposeBindingFlag(true);
                $('.modal').css('overflow', 'auto');
            }

            $(document).on('change', 'input', function (e) {
                var url = window.location.pathname;
                var filename = url.substring(url.lastIndexOf('/') + 1);
                if (filename == "AMLThresholds") {
                    Greyinput(e.currentTarget.id);
                }
            });
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: attached() method in AMLThresholds.js';
            logger.logMessage(msg);
        }
    };

    function invokepage() {
        try {
            var parent = $(location).attr('href').split('/').pop();

            if (parent.split('?')[0] == 'AMLThresholds') {
                AtViewModel.ComposeBindingFlag(false);
            } else {
                AtViewModel.ComposeBindingFlag(true);
                $('.modal').css('overflow', 'auto');
            }
            GetAllAssessmentTypes().then(function () {
                AtViewModel.countEntry(0);
                AtViewModel.FactorCountEntry(0);
                $($(document.getElementsByClassName('list-group-item')).get(4)).addClass('active');
                GetSurveyCategoryTabs();
            });
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: invokepage() method in AMLThresholds.js';
            logger.logMessage(msg);
        }
    }
    //function to pull all the assessment types starts here
    function GetAllAssessmentTypes() {
        try {
            return $.ajax({
                url: "/api/Configuration/GetAssessmentTypes",
                type: "GET",
                headers: appsecurity.getSecurityHeaders()
            })
                .success(function (jsonResult, error) {
                    AtViewModel.AssessmentTypeList([]);
                    if (jsonResult != null) {
                        var MappedAssessmentList = $.map(jsonResult, function (result) {
                            return new AssessmentListModel(result);
                        });
                        AtViewModel.AssessmentTypeList(MappedAssessmentList);
                    }
                })
                .fail(function (jsonResult, error) {
                    logger.logError('An error has occurred while fetching the type assessments. Please contact your Administrator.', 'Error', system.getModuleId(AMLQsViewModel), true);
                });
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: GetAllAssessmentTypes() method in AMLThresholds.js';
            logger.logMessage(msg);
        }
    }
    //function to pull al the asssesssment types ends here

    function GetSurveyCategoryTabs() {
        try {
            $.ajax({
                url: "/api/Configuration/GetSurveyCategoryTabsByAssessmentType",
                type: "GET",
                headers: appsecurity.getSecurityHeaders(),
                data: { "AssessmentId": AtViewModel.SelectedAssessmentId(), "ScreenType": "T" }
            })
                .success(function (jsonResult, success) {
                    try {
                        if (jsonResult != null) {
                            var mappedTabList = $.map(jsonResult, function (result) {
                                return new SurveyCategoryModel(result);
                            });
                            $('#loadingMainImgDivTh').show();
                            AtViewModel.SurveyCategoryListTh(mappedTabList);
                            $('#InherentTabDivTh').tabs();
                            $('#InherentTabDivTh').tabs('refresh');
                            $('#SurveyCategoryTabsDivTh').tabs({ active: 0 });
                            if (AtViewModel.ComposeBindingFlag() == true) {
                                $('.modal').css('overflow', 'auto');
                            }
                            $($('#SurveyCategoryTabsDivTh li').get(0)).trigger('click');
                            scrollableTabs();
                        }
                        else {
                            $('#loadingMainImgDivTh').hide();
                            $('#errorMainTab').show();
                        }
                    }
                    catch (e) {
                        var msg = 'Exception: ' + e + ' | Source: GetSurveyCategoryTabs() Success method in AMLThresholds.js';
                        logger.logMessage(msg);
                    }
                })
                .fail(function (error, status) {
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetSurveyCategoryTabs() method in AMLThresholds.js';
                        logger.logMessage(msg);
                    }
                });
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: GetSurveyCategoryTabs() method in AMLThresholds.js';
            logger.logMessage(msg);
        }
    }

    function SurveyCategoryTabClickTh(data, event) {
        try {
            $("#saveEditButtons").hide();
            $('#loadingMainImgDivTh').show();
            $('#FilterAreaAccordion').show();

            $('#SurveyCategoryTabsDivTh li').removeClass('active');
            $('#ParentTab_' + data.SurveyCategoryId()).addClass('active');

            AtViewModel.SelectedSurveyComponentIdTh(data.SurveyCategoryId());
            if (data.SurveyGroupShortName() == 'QTDR') {
                AtViewModel.ClickedRiskAreaType('QTDR');
            }
            else {
                AtViewModel.ClickedRiskAreaType('QLDR');
            }
            AtViewModel.RiskAreaListTh([]);
            AtViewModel.SurveyTypeClicked(data.SurveyGroupShortName());
            if (data.SurveyCategoryId() === 0)
                OverallTabClick(data, event);
            else
                InitiateLevelTree();
            $('#loadingMainImgDivTh').hide();
            $("#spanExpandAllIT").text((!AtViewModel.LocaleCheckFlag() || AtViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ExpandButton') == -1) ? 'Expand' : AtViewModel.ObjGeneralSettings.LocalizedTextList()[AtViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ExpandButton')].Name());
            $("#arrowSpanIT").addClass("fa-caret-right").removeClass("fa-caret-down");
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: SurveyCategoryTabClickTh() method in AMLThresholds.js';
            logger.logMessage(msg);
        }
    }
    //--------------------------------------------------------------------draw threshold table--------------------------------------------------------------------------
    function Greyinput(id) {
        try {
            var z = $('#' + id).val();
            if (z == 100) {
                $('#' + id).addClass("grey");
                $('#' + id).removeClass("whiteinput");
            }
            else {
                $('#' + id).addClass("whiteinput");
                $('#' + id).removeClass("grey");
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: Greyinput() method in AMLThresholds.js';
            logger.logMessage(msg);
        }
    }
    function GreyOutCells() {
        try {
            for (var i = 1; i < AtViewModel.ThresholdValuesList().length; i++) {
                var x = AtViewModel.ThresholdValuesList()[i].IrlId()
                for (var j = 0; j < AtViewModel.ThresholdChildList().length; j++) {
                    var y = AtViewModel.ThresholdChildList()[j].RiskLevelId()
                    var z = $('#' + y + '_' + x).val()
                    if (z == 100) {
                        $('#' + y + '_' + x).addClass("grey");
                        $('#' + y + '_' + x).removeClass("whiteinput");
                    }
                    else {
                        $('#' + y + '_' + x).addClass("whiteinput");
                        $('#' + y + '_' + x).removeClass("grey");
                    }
                }
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: GreyOutCells() method in AMLThresholds.js';
            logger.logMessage(msg);
        }
    }
    function InputChange() {
        GreyOutCells();
        AtViewModel.InputChangeEvent(true);
    }

    function GetAllRiskFactors() {
        try {
            AtViewModel.PrevRAId(AtViewModel.ClickedRiskAreaId());
            $.ajax({
                url: "/api/Configuration/GetAllRiskfactorAreaWise",
                data: { "RiskAreaId": AtViewModel.ClickedRiskAreaId(), "AssessmentTypes": AtViewModel.SelectedAssessmentId(), "SurveyCategoryID": AtViewModel.SelectedSurveyComponentIdTh(), "ScreenType": "T" },
                type: "GET",
                async: false,
                headers: appsecurity.getSecurityHeaders()
            })
                .success(ajaxSuccess)
                .fail(ajaxFail);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax call in GetAllRiskFactors() method in AMLThresholds.js';
            logger.logMessage(msg);
        }

        function ajaxSuccess(jsonResult, status) {
            try {
                if (jsonResult.length == 0) {
                    $('#RiskAreaTabDivTh').hide();
                    $('#error').show();
                }
                else if (jsonResult != null && jsonResult[0].RiskFactorName != null) {
                    $('#error').hide();
                    var mappedRiskFactorListTh = $.map(jsonResult, function (result) {
                        return new RiskFactorModel(result);
                    });
                    AtViewModel.RiskFactorListTh(mappedRiskFactorListTh);

                    $('#RfTabTh').tabs();
                    $('#RfTabTh').tabs('refresh');
                    $('#RfTabTh').tabs({ active: 0 });
                    $($('#RfTabTh li').get(0)).trigger('click');
                    scrollableTabs();
                }
                else if (jsonResult[0].RiskFactorName == null) {
                    app.showMessage("Risk Factors are not yet configured for this year of assessment. Please configure the Risk Factors to before setting Thresholds.", "Risk Factors not configured.", ["OK"])
                        .then(function (option) {
                            if (option == "OK")
                                router.navigate("configuration/RisksAreasfactors", true);
                        })
                }
                else
                    logger.logError('An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(AtViewModel), true);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetAllRiskFactors() method in AMLThresholds.js';
                logger.logMessage(msg);
            }
        }

        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();
                        })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetAllRiskFactors() method in AMLThresholds.js';
                    logger.logMessage(msg);
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetAllRiskFactors() method in AMLThresholds.js';
                logger.logMessage(msg);
            }
        }
    }

    function RiskAreaTabClickTh(data, event) {
        try {
            $('#lblThresholdValidation').hide();
            if (data.IsQualitative() == "0") {
                $('#QualitativeTabDivTh').hide();
                $('#loadingImgMainQualTh').hide();
                $('#RfTabTh').show();
                if (AtViewModel.appsecurity.WriteAccess() == false || AtViewModel.appsecurity.WriteAccess() == "false") {
                    AtViewModel.countEntry(0);
                    AtViewModel.FactorCountEntry(0);
                }
                if (AtViewModel.countEntry() == 0) {
                    AtViewModel.countEntry(1);
                    AtViewModel.ClickedRiskAreaId(data.RiskAreaId());
                    AtViewModel.ClickedRiskAreaName(data.RiskAreaName());
                    GetAllRiskFactors();
                }
                else if (AtViewModel.InputChangeEvent() && AtViewModel.SaveButtonClick() == false) {
                    AtViewModel.InputChangeEvent(false);
                    app.showMessage("Please save the data before moving to other tab, otherwise the changes made will be lost.", "Warning", ["Save", "Cancel"], true, { buttonClass: "fa fa-check btn btn-primary", primaryButtonClass: "fa fa-check btn btn-success autofocus" })
                        .then(function (option) {
                            if (option == "Save") {
                                $('#btnSaveThreshold').click();
                                AtViewModel.countEntry(0);
                                AtViewModel.FactorCountEntry(0);
                                if (AtViewModel.ErrorStatus() == 1) {
                                    AtViewModel.ErrorStatus(0);
                                    $('#' + AtViewModel.PrevRAId()).addClass('ui-tabs-active ui-state-active');
                                    $('#' + data.RiskAreaId()).removeClass('ui-tabs-active ui-state-active');
                                }
                                else {
                                    AtViewModel.SaveButtonClick(false);
                                    AtViewModel.countEntry(0);
                                    $('#lblThresholdValidation').hide();
                                    $('#' + AtViewModel.PrevRAId()).removeClass('ui-tabs-active ui-state-active');
                                    $('#' + data.RiskAreaId()).addClass('ui-tabs-active ui-state-active');
                                    RiskAreaTabClickTh(data, event);
                                }
                            }
                            else {
                                AtViewModel.countEntry(1);
                                $('#lblThresholdValidation').hide();
                                AtViewModel.FactorCountEntry(0);
                                $('#' + AtViewModel.PrevRAId()).removeClass('ui-tabs-active ui-state-active');
                                $('#' + data.RiskAreaId()).addClass('ui-tabs-active ui-state-active');
                                AtViewModel.ClickedRiskAreaId(data.RiskAreaId());
                                AtViewModel.ClickedRiskAreaName(data.RiskAreaName());
                                GetAllRiskFactors();
                            }
                        })
                }
                else {
                    AtViewModel.InputChangeEvent(false);
                    AtViewModel.countEntry(0);
                    $('#' + AtViewModel.PrevRAId()).removeClass('ui-tabs-active ui-state-active');
                    $('#' + data.RiskAreaId()).addClass('ui-tabs-active ui-state-active');
                    RiskAreaTabClickTh(data, event);
                }
            }
            else {
                if (data.IsQualitative() == "1")
                    $('#QualitativeTabDivTh').show();
                $('#loadingImgMainQualTh').show();
                $('#RfTabTh').hide();
                $('#qualfactordiv').hide();
                $("#saveEditButtons").hide();
                AtViewModel.ClickedRiskAreaName(data.RiskAreaName());
                AtViewModel.ClickedRiskAreaId(data.RiskAreaId());
                AtViewModel.ClickedRiskAreaType(data.RiskAreaType());
                GetQualThresholdData(AtViewModel.ClickedRiskAreaId());
            }
        }

        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: RiskAreaTabClickTh() method in AMLThresholds.js';
            logger.logMessage(msg);
        }
    }

    function RiskFactorTabClickTh(data, event) {
        try {
            $('#QualitativeTabDivTh').hide();
            if (AtViewModel.appsecurity.WriteAccess() == false || AtViewModel.appsecurity.WriteAccess() == "false") {
                AtViewModel.FactorCountEntry(0);
            }
            if (data.RiskAreaId() === data.RiskFactorId()) {
                $('#QualitativeTabDivTh').show();
                $('#RiskFactorTabDivTh').hide();
                $('#loadingImgMainQualTh').hide();
                GetQualThresholdData(data.RiskAreaId());
                return false;
            }
            if (AtViewModel.FactorCountEntry() == 0) {
                AtViewModel.FactorCountEntry(1);
                $('#loadingImgMainTh').show();
                $('#FactorDataDivTh').hide();
                $('#lblThresholdValidation').hide();
                AtViewModel.ClickedRiskFactorId(data.RiskFactorId());
                AtViewModel.ClickedRiskFactorName(data.RiskFactorName());
                AtViewModel.ClickedRAType(data.RA_Type());
                $('#FAC_' + AtViewModel.PrevFactorId()).removeClass('ui-tabs-active ui-state-active');
                $('#FAC_' + data.RiskFactorId()).addClass('ui-tabs-active ui-state-active');
                GetThresholdData();
            }
            else if (AtViewModel.InputChangeEvent() && AtViewModel.SaveButtonClick() == false) {
                AtViewModel.InputChangeEvent(false);
                app.showMessage("Please save the data before moving to another tab, otherwise the changes made will be lost.", "Warning", ["Save", "Cancel"], true, { buttonClass: "fa fa-check btn btn-primary", primaryButtonClass: "fa fa-check btn btn-success autofocus" })
                    .then(function (option) {
                        if (option == "Save") {
                            $('#btnSaveThreshold').click();
                            AtViewModel.FactorCountEntry(0);
                            if (AtViewModel.ErrorStatus() == 1) {
                                AtViewModel.ErrorStatus(0);
                                $('#FAC_' + AtViewModel.PrevFactorId()).addClass('ui-tabs-active ui-state-active');
                                $('#FAC_' + data.RiskFactorId()).removeClass('ui-tabs-active ui-state-active');
                            }
                            else {
                                AtViewModel.SaveButtonClick(false);
                                AtViewModel.FactorCountEntry(0);
                                $('#FAC_' + AtViewModel.PrevFactorId()).removeClass('ui-tabs-active ui-state-active');
                                $('#FAC_' + data.RiskFactorId()).addClass('ui-tabs-active ui-state-active');
                                RiskFactorTabClickTh(data, event);
                            }
                        }
                        else {
                            AtViewModel.FactorCountEntry(1);
                            $('#lblThresholdValidation').hide();
                            $('#FAC_' + AtViewModel.PrevFactorId()).removeClass('ui-tabs-active ui-state-active');
                            $('#FAC_' + data.RiskFactorId()).addClass('ui-tabs-active ui-state-active');
                            $('#loadingImgMainTh').show();
                            $('#FactorDataDivTh').hide();
                            AtViewModel.ClickedRiskFactorId(data.RiskFactorId());
                            AtViewModel.ClickedRiskFactorName(data.RiskFactorName());
                            AtViewModel.ClickedRAType(data.RA_Type());
                            GetThresholdData();
                        }
                    })
            }
            else {
                AtViewModel.InputChangeEvent(false);
                AtViewModel.SaveButtonClick(false);
                AtViewModel.FactorCountEntry(0);
                $('#FAC_' + AtViewModel.PrevFactorId()).removeClass('ui-tabs-active ui-state-active');
                $('#FAC_' + data.RiskFactorId()).addClass('ui-tabs-active ui-state-active');
                RiskFactorTabClickTh(data, event);
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: RiskFactorTabClickTh() method in AMLThresholds.js';
            logger.logMessage(msg);
        }
    }

    function OverallTabClick(data, event) {
        try {
            $('#loadingImgMainQualTh').show();

            $('#RfTabTh').hide();
            $('#FilterAreaAccordion').hide();
            $("#saveEditButtons").hide();
            $('#overalldiv').hide();
            GetOverallThresholdData();
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: OverallTabClick() method in AMLThresholds.js';
            logger.logMessage(msg);
        }
    }

    function GetThresholdData() {
        try {
            AtViewModel.PrevFactorId(AtViewModel.ClickedRiskFactorId());
            $.ajax({
                url: "/api/WeightingsThresholds/GetFactorThreshold?TableId=" + AtViewModel.ClickedRiskFactorId() + "&AssessmentType=" + AtViewModel.SelectedAssessmentId() +
                    "&TableType=" + AtViewModel.ClickedRAType() + "&SurveyCategoryId=" + AtViewModel.SelectedSurveyComponentIdTh(),
                type: "GET",
                headers: appsecurity.getSecurityHeaders()
            })
                .success(ajaxSuccess)
                .fail(ajaxFail);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: GetThresholdData() method in AMLThresholds.js';
            logger.logMessage(msg);
        }

        function ajaxSuccess(jsonResult, status) {
            try {
                if (jsonResult == 0 || jsonResult == null) {
                    $('#loadingImgMainTh').hide();
                    $('#FactorDataDivTh').show();
                    $('#NoDataErrorThresholds').show();
                }
                else {
                    $('#NoDataErrorThresholds').hide();
                    $('#loadingImgMainTh').hide();
                    $('#FactorDataDivTh').show();
                    var MappedThresholdValue = $.map(jsonResult, function (result) {
                        return new ThresholdValueModel(result);
                    });
                    $('#tblThreshold tbody tr').remove();
                    AtViewModel.ThresholdValuesList(MappedThresholdValue);

                    var MappedThresholdValueDup = $.map(jsonResult, function (result) {
                        return new ThresholdValueModel(result);
                    });
                    AtViewModel.ThresholdValuesListDup(MappedThresholdValueDup);

                    AtViewModel.ThresholdChildList(AtViewModel.ThresholdValuesList()[0].ChildList());
                    GreyOutCells();

                    if (AtViewModel.ComposeBindingFlag()) {
                        $("#btnSaveThreshold").hide();
                        $("#btnCancelThreshold").hide();
                        $("#btnSaveThreshold1").hide();
                        $("#btnCancelThreshold1").hide();
                    }
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetThresholdData() method in AMLThresholds.js';
                logger.logMessage(msg);
            }
        }

        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();
                        })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetThresholdData() method in AMLThresholds.js';
                    logger.logMessage(msg);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail  in GetThresholdData() method in AMLThresholds.js';
                logger.logMessage(msg);
            }
        }
    }

    function ThresholdCellBlur(data, event) {
        try {
            var RiskLevelId = event.currentTarget.parentNode.parentNode.id;
            var Value = event.currentTarget.value;
            ValidateThresholdValues(data.IrlId(), RiskLevelId, Value);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ThresholdCellBlur() method in AMLThresholds.js';
            logger.logMessage(msg);
        }
    }

    function ValidateThresholdValues(IrlId, RiskLevelId, Value) {
        try {
            var Result = false;
            var ColumnIndex = 0;
            var RowIndex = 0;
            for (var i = 0; i < $('#tblThreshold thead tr th').length; i++) {
                if ($('#tblThreshold thead tr th').get(i).id == IrlId)
                    ColumnIndex = i;
            }
            ColumnIndex = (ColumnIndex * 2) + 1;
            for (var i = 0; i < $('#tblThreshold tbody tr').length; i++) {
                if ($($('#tblThreshold tbody tr').get(i)).find('td').get(ColumnIndex).id == RiskLevelId)
                    RowIndex = i;
            }
            var ErrorMsg = "";

            if (Value == "" || Value == undefined) {
                ErrorMsg = "Value cannot be left blank";
                $($($('#tblThreshold tbody tr').get(RowIndex)).find('td').get(ColumnIndex)).find('input').css("border", "1px solid red");
            }
            else if (isNaN(Value)) {
                ErrorMsg = "Non-Numeric Value is not allowed";
                $($($('#tblThreshold tbody tr').get(RowIndex)).find('td').get(ColumnIndex)).find('input').css("border", "1px solid red");
            }
            else if (Value < 0 || Value > 100) {
                ErrorMsg = "Value should be in range 0 - 100";
                $($($('#tblThreshold tbody tr').get(RowIndex)).find('td').get(ColumnIndex)).find('input').css("border", "1px solid red");
            }
            else {
                if ((parseFloat(Value).toString().indexOf('.') < 0) ? true : ((parseFloat(Value).toString().split('.')[1].length <= 2) ? true : false)) {
                    $($($('#tblThreshold tbody tr').get(RowIndex)).find('td').get(ColumnIndex)).find('input').removeAttr('style');
                    ErrorMsg = "";
                    Result = true;
                }
                else {
                    ErrorMsg = "Decimal Upto Only 2 Places is Allowed";
                    $($($('#tblThreshold tbody tr').get(RowIndex)).find('td').get(ColumnIndex)).find('input').css("border", "1px solid red");
                }
            }
            if (ErrorMsg.length > 0) {
                AtViewModel.ErrorStatus(1);
            }
            $($($('#tblThreshold tbody tr').get(RowIndex)).find('td').get(ColumnIndex)).find('label').text(ErrorMsg);
            return Result;
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ValidateThresholdValues() method in AMLThresholds.js';
            logger.logMessage(msg);
        }
    }

    function ConvertObservableToObject(Data) {
        try {
            var ThresholdValue = new Array();
            for (var i = 0; i < Data().length; i++) {
                var Child = new Array();
                for (j = 0; j < Data()[i].ChildList().length; j++) {
                    Child.push(new Object({
                        RiskLevelId: Data()[i].ChildList()[j].RiskLevelId(),
                        RiskLevelName: Data()[i].ChildList()[j].RiskLevelName(),
                        RiskLevelCss: Data()[i].ChildList()[j].RiskLevelCss()
                    }));
                }
                ThresholdValue.push(new Object({
                    IrlId: Data()[i].IrlId(),
                    IrlName: Data()[i].IrlName(),
                    Child: Child
                }));
            }
            return ThresholdValue;
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ConvertObservableToObject() method in AMLThresholds.js';
            logger.logMessage(msg);
        }
    }

    function ResetThresholdData() {
        try {
            for (var i = 1; i < AtViewModel.ThresholdValuesListDup().length; i++) {
                for (var j = 0; j < AtViewModel.ThresholdValuesListDup()[i].ChildList().length; j++) {
                    var Value = AtViewModel.ThresholdValuesListDup()[i].ChildList()[j].RiskLevelName();
                    AtViewModel.ThresholdValuesList()[i].ChildList()[j].RiskLevelName(Value);
                }
            }
            $('#tblThreshold tbody input').removeAttr('style');
            $('#tblThreshold tbody #lblValidation').text("");
            $('#lblThresholdValidation').text("");
            $('#lblThresholdValidation').hide();
            GreyOutCells();
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ResetThresholdData() method in AMLThresholds.js';
            logger.logMessage(msg);
        }
    }

    function SaveThresholdBtnClick() {
        try {
            AtViewModel.SaveButtonClick(true);
            var Counter = 0;
            for (var i = 1; i < AtViewModel.ThresholdValuesList().length; i++) {
                for (var j = 0; j < AtViewModel.ThresholdValuesList()[i].ChildList().length; j++) {
                    if (!(ValidateThresholdValues(AtViewModel.ThresholdValuesList()[i].IrlId(), AtViewModel.ThresholdValuesList()[i].ChildList()[j].RiskLevelId(), AtViewModel.ThresholdValuesList()[i].ChildList()[j].RiskLevelName())))
                        Counter++;
                }
            }
            if (Counter == 0) {
                $('#lblThresholdValidation').text("");
                $('#lblThresholdValidation').hide();
                var ObjectData = ConvertObservableToObject(AtViewModel.ThresholdValuesList);
                SaveThresholdValues(ObjectData);
            }
            else {
                $('#lblThresholdValidation').text("Please correct the errors highlighted in below cells before saving the Threshold Data.");
                $('#lblThresholdValidation').show();
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: SaveThresholdBtnClick() method in AMLThresholds.js';
            logger.logMessage(msg);
        }
    }

    function SaveThresholdValues(ObjectData) {
        try {
            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;
            $.ajax({
                url: "/api/WeightingsThresholds/saveFactorThreshold?TableId=" + AtViewModel.ClickedRiskFactorId() + "&AssessmentType=" + AtViewModel.SelectedAssessmentId() +
                    "&TableType=F&SurveyCategoryId=" + AtViewModel.SelectedSurveyComponentIdTh() + "&copyFlag=" + AtViewModel.copyToAllFlag(),
                headers: headers,
                type: "POST",
                contentType: 'application/json',
                dataType: 'json',
                data: JSON.stringify(ObjectData)
            })
                .success(ajaxSuccess)
                .fail(ajaxFail);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax call in SaveThresholdValues() method in AMLThresholds.js';
            logger.logMessage(msg);
        }

        function ajaxSuccess(jsonResult, status) {
            try {
                AtViewModel.copyToAllFlag(0);
                if (jsonResult == "1") {
                    for (var i = 1; i < AtViewModel.ThresholdValuesList().length; i++) {
                        for (var j = 0; j < AtViewModel.ThresholdValuesList()[i].ChildList().length; j++) {
                            var Value = AtViewModel.ThresholdValuesList()[i].ChildList()[j].RiskLevelName();
                            AtViewModel.ThresholdValuesListDup()[i].ChildList()[j].RiskLevelName(Value);
                        }
                    }
                    logger.logSuccess('Threshold Data saved successfully.', 'Success', system.getModuleId(AtViewModel), true);
                }
                else
                    logger.logError(jsonResult + ' - An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(AtViewModel), true);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in SaveThresholdValues() method in AMLThresholds.js';
                logger.logMessage(msg);
            }
        }

        function ajaxFail(error, status) {
            try {
                AtViewModel.copyToAllFlag(0);
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();
                        })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in SaveThresholdValues() method in AMLThresholds.js';
                    logger.logMessage(msg);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail  in SaveThresholdValues() method in AMLThresholds.js';
                logger.logMessage(msg);
            }
        }
    }

    //-------------------------------------------------------------Model Definition Starts Here-----------------------------------------------------------------------
  
    function RiskFactorModel(item) {
        try {
            var self = this;
            self.RiskFactorName = ko.observable($('<div/>').html(item.RiskFactorName).text());
            self.RiskFactorId = ko.observable(item.RiskFactorId);
            self.RiskAreaId = ko.observable(item.RiskAreaId);
            self.RiskAreaName = ko.observable($('<div/>').html(item.RiskAreaName).text());
            self.TargetRow = ko.observable();
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: RiskFactorModel() method in AMLThresholds.js';
            logger.logMessage(msg);
        }
    };

    function ThresholdValueModel(item) {
        try {
            var self = this;
            self.IrlId = ko.observable(item.IrlId);
            self.IrlName = ko.observable(item.IrlName);
            var MappedChild = $.map(item.Child, function (result) {
                return new ThresholdChildModel(result);
            });
            self.ChildList = ko.observableArray(MappedChild);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ThresholdValueModel() method in AMLThresholds.js';
            logger.logMessage(msg);
        }
    }

    function ThresholdChildModel(item) {
        try {
            var self = this;
            self.RiskLevelId = ko.observable(item.RiskLevelId);
            self.RiskLevelName = ko.observable(item.RiskLevelName);
            self.RiskLevelCss = ko.observable(item.RiskLevelCss);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ThresholdChildModel() method in AMLThresholds.js';
            logger.logMessage(msg);
        }
    }

    function SurveyCategoryModel(item) {
        try {
            var self = this;
            self.SurveyCategoryId = ko.observable(item.SurveyCategoryId);
            self.SurveyCategoryName = ko.observable(item.SurveyCategoryName);
            self.SurveyCategoryShortName = ko.observable(item.SurveyCategoryShortName);
            self.SurveyType = ko.observable(item.SurveyType);
            self.Applicability = ko.observable(item.Applicability);
            self.SurveyGroupId = ko.observable(item.SurveyGroupId);
            self.SurveyGroupFullName = ko.observable(item.SurveyGroupFullName);
            self.SurveyGroupShortName = ko.observable(item.SurveyGroupShortName);
            self.IsEditable = ko.observable(item.IsEditable);
            self.AssessmentTypeId = ko.observable(item.AssessmentTypeId);
            self.AssessmentTypeName = ko.observable(item.AssessmentTypeName);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: SurveyCategoryModel() method in AMLThresholds.js';
            logger.logMessage(msg);
        }
    }
    //-------------------------------------------------------------Model Definition Ends Here-----------------------------------------------------------------------

    function ValidateThresholdsValues(data) {
        var validation = true;
        if (AtViewModel.SelectedSurveyComponentIdTh() === 0) {
            $.each(AtViewModel.OverallThresholdValuesList(), function (index, value) {
                var level = value.Level();
                if (parseFloat(value.Min()) >= parseFloat(value.Max())) {
                    value.ShouldShowMessage(true);
                    value.ValidationMessage("Max should be more then Min");
                    validation = false;
                }
                else if (value.ShouldShowMessage()) {
                    value.ShouldShowMessage(false);
                    value.ValidationMessage(null);
                    validation = true;
                }
            });
        }
        else {
            $.each(AtViewModel.QualThresholdValuesList(), function (index, value) {
                var level = value.Level();
                if (parseFloat(value.Min()) >= parseFloat(value.Max())) {
                    value.ShouldShowMessage(true);
                    value.ValidationMessage("Max should be more then Min");
                    validation = false;
                }
                else if (value.ShouldShowMessage()) {
                    value.ShouldShowMessage(false);
                    value.ValidationMessage(null);
                    validation = true;
                }
            });
        }
        return validation;
    }

    function SaveQualitativeThresholdValues(data) {
        try {
            var jsonString = "";
            var copyFlag = AtViewModel.copyToAllFlag();
            var TableId = AtViewModel.ClickedRiskAreaId();

            var ValidFlagQ = 1;
            var ValidFlagO = 1;

            for (var i = 0; i < AtViewModel.QualThresholdValuesList().length; i++) {
                if (AtViewModel.QualThresholdValuesList()[i].Max() == '') {
                    ValidFlag = 0;
                }
            }

            // Minimum of current level cannot be greater than maximum of previous level
            var previousMaxQ = 0;
            for (let i = 0; i < AtViewModel.QualThresholdValuesList().length; i++)
            {
                if (i == 0) {
                    if (parseFloat(AtViewModel.QualThresholdValuesList()[i].Min()) > parseFloat(AtViewModel.QualThresholdValuesList()[i].Max())) {
                        ValidFlagQ = 0;
                        break;
                    }
                }
                else {
                    if ((parseFloat(AtViewModel.QualThresholdValuesList()[i].Min()) > parseFloat(AtViewModel.QualThresholdValuesList()[i].Max())) || (parseFloat(AtViewModel.QualThresholdValuesList()[i].Min()) < previousMaxQ)) {
                        ValidFlagQ = 0;
                        break;
                    }
                }
                previousMax = AtViewModel.QualThresholdValuesList()[i].Max();
            }

            var previousMaxO = 0;
            for (let i = 0; i < AtViewModel.OverallThresholdValuesList().length; i++) {
                if (i == 0) {
                    if (parseFloat(AtViewModel.OverallThresholdValuesList()[i].Min()) > parseFloat(AtViewModel.OverallThresholdValuesList()[i].Max())) {
                        ValidFlagO = 0;
                        break;
                    }
                }
                else {
                    if ((parseFloat(AtViewModel.OverallThresholdValuesList()[i].Min()) > parseFloat(AtViewModel.OverallThresholdValuesList()[i].Max())) || (parseFloat(AtViewModel.OverallThresholdValuesList()[i].Min()) < previousMaxO)) {
                        ValidFlagO = 0;
                        break;
                    }
                }
                previousMaxO = AtViewModel.OverallThresholdValuesList()[i].Max();
            }
            if (ValidFlagQ == 1 || ValidFlagO == 1)
            {
                var TableType = "";
                if (AtViewModel.SelectedSurveyComponentIdTh() === 0) {
                    jsonString = $.map(AtViewModel.OverallThresholdValuesList(), function (result) {
                        return {
                            Uid: result.Uid(),
                            FinalRiskId: result.FinalRiskId(),
                            Min: result.Min(),
                            Max: result.Max(),
                            Description: result.Description(),
                            Level: result.Level(),
                            Css: result.CSS()
                        }
                    });
                    TableId = 0;
                    TableType = "B";
                }
                else {
                    jsonString = $.map(AtViewModel.QualThresholdValuesList(), function (result) {
                        return {
                            Uid: result.Uid(),
                            FinalRiskId: result.FinalRiskId(),
                            Min: result.Min(),
                            Max: result.Max(),
                            Description: result.Description(),
                            Level: result.Level(),
                            Css: result.CSS()
                        }
                    });
                    TableType = (AtViewModel.ClickedRAType()=="F" && AtViewModel.ClickedRiskAreaType()=="QLDR") ? "H" : AtViewModel.ClickedRAType() ;
                }

                if (ValidateThresholdsValues(data)) {
                    var csrfToken = $("input[name='__RequestVerificationToken']").val();
                    var headers = appsecurity.getSecurityHeaders();
                    headers.__RequestVerificationToken = csrfToken;
                    $.ajax({
                        url: "/api/WeightingsThresholds/saveFactorThreshold?TableId=" + TableId + "&AssessmentType=" + AtViewModel.SelectedAssessmentId() +
                            "&TableType=" + TableType + "&SurveyCategoryId=" + AtViewModel.SelectedSurveyComponentIdTh() + "&CopyFlag=" + copyFlag,
                        headers: headers,
                        traditional: true,
                        type: "POST",
                        contentType: 'application/json',
                        dataType: 'json',
                        data: JSON.stringify(jsonString)
                    })
                        .success(ajaxSuccess)
                        .fail(ajaxFail);
                }
            }
            else {
                GetQualThresholdData(AtViewModel.ClickedRiskAreaId());
                logger.logError('Please enter valid Numeric Values.', 'Error', system.getModuleId(AtViewModel), true);
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax call in SaveQualitativeThresholdValues() method in AMLThresholds.js';
            logger.logMessage(msg);
        }

        function ajaxSuccess(jsonResult, status) {
            try {
                AtViewModel.copyToAllFlag(0);
                if (jsonResult == "1") {
                    if (AtViewModel.SelectedSurveyComponentIdTh() === 0)
                        GetOverallThresholdData();
                    else
                        GetQualThresholdData(AtViewModel.ClickedRiskAreaId());
                    logger.logSuccess('Qualitative Threshold Data saved successfully.', 'Success', system.getModuleId(AtViewModel), true);
                }
                else
                    logger.logError(jsonResult + ' - An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(AtViewModel), true);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in SaveQualitativeThresholdValues() method in AMLThresholds.js';
                logger.logMessage(msg);
            }
        }
        function ajaxFail(error, status) {
            try {
                AtViewModel.copyToAllFlag(0);
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();
                        })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in SaveQualitativeThresholdValues() method in AMLThresholds.js';
                    logger.logMessage(msg);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail  in SaveQualitativeThresholdValues() method in AMLThresholds.js';
                logger.logMessage(msg);
            }
        }
    }

    function GetQualThresholdData(data) {
        try {
            $.ajax({
                url: "/api/WeightingsThresholds/GetQualFactorThreshold",
                data: {
                    "TableId": parseInt(data), "AssessmentType": AtViewModel.SelectedAssessmentId(), "TableType": (AtViewModel.ClickedRAType() == "F" && AtViewModel.ClickedRiskAreaType() == "QLDR") ? "H" : AtViewModel.ClickedRAType(), "SurveyCategoryId": AtViewModel.SelectedSurveyComponentIdTh()
                },
                type: "GET",
                headers: appsecurity.getSecurityHeaders()
            })
                .success(ajaxSuccess)
                .fail(ajaxFail);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: GetQualThresholdData() method in AMLThresholds.js';
            logger.logMessage(msg);
        }

        function ajaxSuccess(jsonResult, status) {
            try {
                if (jsonResult == 0 || jsonResult == null) {
                    $('#loadingImgMainQualTh').hide();
                    $('#qualfactordiv').show();
                    $("#saveEditButtons").show();
                    $('#NoDataErrorQualThresholds').show();
                }
                else {
                    $('#NoDataErrorQualThresholds').hide();
                    $("#error").hide();
                    $('#loadingImgMainQualTh').hide();
                    $('#qualfactordiv').show();
                    $("#saveEditButtons").show();
                    var MappedQualThresholdValue = $.map(jsonResult, function (result) {
                        return new QualThresholdValueModel(result);
                    });
                    $('#tblThreshold tbody tr').remove();
                    AtViewModel.QualThresholdValuesList(MappedQualThresholdValue);

                    var MappedThresholdValueDup = $.map(jsonResult, function (result) {
                        return new QualThresholdValueModel(result);
                    });
                    AtViewModel.QualThresholdValuesListDup(MappedThresholdValueDup);
                    if (AtViewModel.ComposeBindingFlag()) {
                        $("#btnSaveThreshold").hide();
                        $("#btnCancelThreshold").hide();
                        $("#btnSaveThreshold1").hide();
                        $("#btnCancelThreshold1").hide();
                    }
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetQualThresholdData() method in AMLThresholds.js';
                logger.logMessage(msg);
            }
        }

        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();
                        })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetQualThresholdData() method in AMLThresholds.js';
                    logger.logMessage(msg);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail  in GetQualThresholdData() method in AMLThresholds.js';
                logger.logMessage(msg);
            }
        }
    }

    function copyToAll(data, event) {
        try {
            app.showMessage('Are you sure you want to Copy Thresholds to all Levels, It will clear all previously saved values?', 'Apply Changes', ['Confirm', 'Cancel'], false, { primaryButtonClass: "mr-2 btn-curved fa fa-check btn btn-success autofocus", secondaryButtonClass: "mr-2 btn-curved fa fa-times btn btn-default", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-edit text-default' })
                .then(function (option) {
                    if (option === 'Confirm') {
                        console.log(AtViewModel.ClickedRiskAreaType());
                        AtViewModel.copyToAllFlag(1);
                        if (AtViewModel.ClickedRiskAreaType() === 'QLDR' || (AtViewModel.ClickedRiskAreaType() == 'QTDR' && AtViewModel.ClickedRAType() == 'A')) {
                            // CALL THE QUALITTATIVE SAVE WITH FLAG = 1
                            SaveQualitativeThresholdValues();
                        }
                        else {
                            SaveThresholdBtnClick();
                            // CALL THE QUANTITATIVE SAVE WITH FLAG = 0
                        }
                    }
                });
        }
        catch (e) {
            let msg = 'Exception: ' + e + ' | Source: copyToAll() method in AMLThresholds.js';
            logger.logMessage(msg);
        }
    }

    function GetOverallThresholdData() {
        try {
            $.ajax({
                url: "/api/WeightingsThresholds/GetOverallThresholdData",
                data: {
                    "TableId": 0, "AssessmentType": AtViewModel.SelectedAssessmentId(), "TableType": "B", "SurveyCategoryId": AtViewModel.SelectedSurveyComponentIdTh()
                },
                type: "GET",
                headers: appsecurity.getSecurityHeaders()
            })
                .success(ajaxSuccess)
                .fail(ajaxFail);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: GetOverallThresholdData() method in AMLThresholds.js';
            logger.logMessage(msg);
        }

        function ajaxSuccess(jsonResult, status) {
            try {
                if (jsonResult == 0 || jsonResult == null) {
                    $('#loadingImgMainQualTh').hide();
                    $('#overalldiv').show();
                    $("#saveEditButtons").show();
                    $('#NoDataErrorOverallThresholds').show();
                }
                else {
                    $('#NoDataErrorOverallThresholds').hide();
                    $("#error").hide();
                    $('#loadingImgMainQualTh').hide();
                    $('#overalldiv').show();
                    $("#saveEditButtons").show();
                    var MappedQualThresholdValue = $.map(jsonResult, function (result) {
                        return new QualThresholdValueModel(result);
                    });
                    $('#tblThreshold tbody tr').remove();
                    AtViewModel.OverallThresholdValuesList(MappedQualThresholdValue);

                    var MappedThresholdValueDup = $.map(jsonResult, function (result) {
                        return new QualThresholdValueModel(result);
                    });
                    AtViewModel.OverallThresholdValuesListDup(MappedThresholdValueDup);
                    if (AtViewModel.ComposeBindingFlag()) {
                        $("#btnSaveThreshold").hide();
                        $("#btnCancelThreshold").hide();
                        $("#btnSaveThreshold1").hide();
                        $("#btnCancelThreshold1").hide();
                    }
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetOverallThresholdData() method in AMLThresholds.js';
                logger.logMessage(msg);
            }
        }

        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();
                        })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetOverallThresholdData() method in AMLThresholds.js';
                    logger.logMessage(msg);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail  in GetOverallThresholdData() method in AMLThresholds.js';
                logger.logMessage(msg);
            }
        }
    }

    function ResetQualitativeThresholdValues(data) {
        try {
            if (AtViewModel.SelectedSurveyComponentIdTh() === 0) {
                for (var i = 0; i < AtViewModel.OverallThresholdValuesList().length; i++) {
                    var valuemax = AtViewModel.OverallThresholdValuesListDup()[i].Max();
                    var valuemin = AtViewModel.OverallThresholdValuesListDup()[i].Min();
                    AtViewModel.OverallThresholdValuesList()[i].Min(valuemin);
                    AtViewModel.OverallThresholdValuesList()[i].Max(valuemax);
                    AtViewModel.OverallThresholdValuesList()[i].ValidationMessage("");
                    AtViewModel.OverallThresholdValuesList()[i].ValidationMessageMin("");
                }
            }
            else {
                for (var i = 0; i < AtViewModel.QualThresholdValuesList().length; i++) {
                    var valuemax = AtViewModel.QualThresholdValuesListDup()[i].Max();
                    var valuemin = AtViewModel.QualThresholdValuesListDup()[i].Min();
                    AtViewModel.QualThresholdValuesList()[i].Min(valuemin);
                    AtViewModel.QualThresholdValuesList()[i].Max(valuemax);
                    AtViewModel.QualThresholdValuesList()[i].ValidationMessage("");
                    AtViewModel.QualThresholdValuesList()[i].ValidationMessageMin("");
                }
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajaxFail  in ResetQualitativeThresholdValues() method in AMLThresholds.js';
            logger.logMessage(msg);
        }
    }

    function onKeyPressvalidateNumber(data, event) {
        var charCode = (event.which) ? event.which : event.keyCode;
        if (charCode != 46 && charCode > 31 && charCode != 45
            && (charCode < 48 || charCode > 57))
            return false;
        return true;
    }

    function onBlurMin(data) {
        var level = data.Level() - 1;
        if ($.isNumeric(data.Min())) {
            if (AtViewModel.SelectedSurveyComponentIdTh() === 0) {
                for (var i = 0; i < AtViewModel.OverallThresholdValuesList().length; i++) {
                    var comp = AtViewModel.OverallThresholdValuesList()[i];
                    if (comp.Level() == (level)) {
                        if (Number(data.Min()) < Number(comp.Max())) {
                            data.ShouldShowMessageMin(true);
                            data.ValidationMessageMin("Min should be more than Max of previous level");
                            return;
                        }
                    }
                }
            }
            else {
                for (var i = 0; i < AtViewModel.QualThresholdValuesList().length; i++) {
                    var comp = AtViewModel.QualThresholdValuesList()[i];
                    if (comp.Level() == (level)) {
                        if (Number(data.Min()) < Number(comp.Max())) {
                            data.ShouldShowMessageMin(true);
                            data.ValidationMessageMin("Min should be more than Max of previous level");
                            return;
                        }
                    }
                }
            }
            if (Number(data.Min()) >= Number(data.Max())) {
                data.ShouldShowMessageMin(true);
                data.ValidationMessageMin("Min should be less than Max");
                return;
            }
        }
        else {
            data.ShouldShowMessageMin(true);
            data.ValidationMessageMin("Non numeric values are not allowed");
            return;
        }
        data.ShouldShowMessageMin(false);
        data.ValidationMessageMin("");
    }

    function onBlurEvent(data) {
        var level = data.Level();
        if ($.isNumeric(data.Max())) {
            if (Number(data.Min()) >= Number(data.Max())) {
                data.ShouldShowMessage(true);
                data.ValidationMessage("Max should be more than Min");
            }
            else {
                data.ShouldShowMessage(false);
                data.ValidationMessage(null);
                if (AtViewModel.SelectedSurveyComponentIdTh() === 0) {
                    $.each(AtViewModel.OverallThresholdValuesList(), function (index, value) {
                        if (value.Level() == (level + 1)) {
                            var splitstr = (data.Max().toString().indexOf('.') > 0) ? data.Max().toString().split('.') : data.Max();
                            var count = 0;
                            if (Array.isArray(splitstr) && splitstr.length > 1)
                                count = splitstr[1].length;
                            else
                                count = 1;

                            var num = Math.pow(10, -count);
                            if (isNaN(num)) num = 0;
                            value.Min(parseFloat(parseFloat(data.Max()) + parseFloat(num)).toFixed(count));
                        }
                    });
                }
                else {
                    $.each(AtViewModel.QualThresholdValuesList(), function (index, value) {
                        if (value.Level() == (level + 1)) {
                            var splitstr = (data.Max().toString().indexOf('.') > 0) ? data.Max().toString().split('.') : data.Max();
                            var count = 0;
                            if (Array.isArray(splitstr) && splitstr.length > 1)
                                count = splitstr[1].length;
                            else
                                count = 1;

                            var num = Math.pow(10, -count);
                            if (isNaN(num)) num = 0;
                            value.Min(parseFloat(parseFloat(data.Max()) + parseFloat(num)).toFixed(count));
                        }
                    });
                }
            }
        }
        else {
            data.ShouldShowMessage(true);
            data.ValidationMessage("Non numeric values are not allowed");
        }
    }
    function AssessmentListModel(item) {
        try {
            var self = this;
            self.AssessmentId = ko.observable($('<div/>').html(item.AssessmentId).text());
            self.AssessmentName = ko.observable(item.AssessmentName);
            self.AssessmentDisplayName = ko.observable($('<div/>').html(item.AssessmentDisplayName).text());
            self.Description = ko.observable($('<div/>').html(item.Description).text());
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: AssessmentListModel() method in AMLThresholds.js';
            logger.logMessage(msg);
        }
    }
    function QualThresholdValueModel(item) {
        try {
            var self = this;
            self.Uid = ko.observable(item.Uid);
            self.FinalRiskId = ko.observable(item.FinalRiskId);
            self.Min = ko.observable(item.Min);
            self.Max = ko.observable(item.Max);
            self.ValidationMessage = ko.observable(null);
            self.ShouldShowMessage = ko.observable(false);
            self.ValidationMessageMin = ko.observable(null);
            self.ShouldShowMessageMin = ko.observable(false);
            self.onBlur = function (data) {
                onBlurEvent(data);
            };
            self.Description = ko.observable($('<div/>').html(item.Description).text());
            self.CSS = ko.observable(item.Css);
            self.Level = ko.observable(item.Level);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: QualThresholdValueModel() method in AMLThresholds.js';
            logger.logMessage(msg);
        }
    }

    function CollapseAllTreeView() {
        if ($('#spanExpandAllIT').text() == ((!AtViewModel.LocaleCheckFlag() || AtViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ExpandButton') == -1) ? 'Expand' : AtViewModel.ObjGeneralSettings.LocalizedTextList()[AtViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ExpandButton')].Name())) {
            $('#jsTreeAreaLevel').treeview('expandAll', { silent: true });
            $("#spanExpandAllIT").text((!AtViewModel.LocaleCheckFlag() || AtViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CollapseButton') == -1) ? 'Collapse' : AtViewModel.ObjGeneralSettings.LocalizedTextList()[AtViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CollapseButton')].Name());
            $("#arrowSpanIT").addClass("fa-caret-down").removeClass("fa-caret-right");
        }
        else {
            $('#jsTreeAreaLevel').treeview('collapseAll', { silent: true });
            $("#spanExpandAllIT").text((!AtViewModel.LocaleCheckFlag() || AtViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ExpandButton') == -1) ? 'Expand' : AtViewModel.ObjGeneralSettings.LocalizedTextList()[AtViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ExpandButton')].Name());
            $("#arrowSpanIT").addClass("fa-caret-right").removeClass("fa-caret-down");
        }
    }

    function ToggleNavigationMenu2() {
        var chk1 = $('#NavigationToggle1');
        chk1.prop("checked", true);
        $("#FilterAreaAccordion").toggleClass("collapsedTreeview");
        $("#bottomDivAreaType").toggleClass("col-lg-12 col-lg-9");
        $("#bottomDivAreaType").toggleClass("col-md-12 col-md-9");
        $("#bottomDivAreaType").toggleClass("col-sm-12 col-sm-9");
        $("#bottomDivAreaType").toggleClass("col-xs-12 col-xs-9");
        $("#divNavSwitch2").hide();
        $("#divjsTree").show();
    }

    function ExpandAllTreeView() {
        $('#jsTreeAreaLevel').treeview('expandAll', { silent: true });
    }

    function InitiateLevelTree()
    {
        try {
            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;
            getJsTreeAreaLevel = {
                url: "/api/Configuration/GetAllRiskAreasForThreshold",
                type: "GET",
                data: { "RiskAreType": AtViewModel.SurveyTypeClicked(), "SurveyCategoryID": AtViewModel.SelectedSurveyComponentIdTh().toString(), "AssessmentTypes": AtViewModel.AssessmentTypeId().toString(), "ScreenType": 'T' },
                headers: headers
            };
            $.ajax(getJsTreeAreaLevel)
                .success(ajaxSuccess)
                .fail(ajaxFail);
        }
        catch (e)
        {
            var msg = 'Exception: ' + e + ' | Source: ajax call in InitiateLevelTree() method in AMLThresholds.js';
            logger.logMessage(msg);
        }

        function ajaxSuccess(jsonResult, status) {
            if (jsonResult != null) {
                //implement js tree logic here
                AtViewModel.AreaLeveljstree(jsonResult.AreaLevelsData);

                var MappedJsTreeList = $.map(jsonResult.AreaLevelsData["#"], function (result) {
                    return new jsTreeModel(result);
                });

                $('#jsTreeAreaLevel').treeview({
                    data: MappedJsTreeList,
                    onNodeSelected: nodeClickEvent
                });

                var hasChildNodes = ko.utils.arrayFilter(MappedJsTreeList, function (i) { if (i.dead_node != 1) { return i; } }).length > 0
                AtViewModel.hasChildNodes(hasChildNodes);

                //for initial load expand for treeview

                $("#jsTreeAreaLevel ul:first li:first").trigger("click");
                $("loadingImgOrCalc").hide();
                $("loadingMainImgDivTh").hide();
                $("loadingImgMainTh").hide();
            }
        }

        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();
                        })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in nodeClickEvent() method in AMLThresholds.js';
                    logger.logMessage(msg);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in nodeClickEvent() method in AMLThresholds.js';
                logger.logMessage(msg);
            }
        }

        function nodeClickEvent(event, node) {
            // Your logic goes here
            AtViewModel.ClickedRiskFactorId(node.id);
            $('#jsTreeAreaLevel').treeview('selectNode', [node.nodeId, { silent: true }]);
            $('#DynamicHTMLDiv').html("");
            $('#QualContDynamicHTMLDiv').html("");
            $('#loadingImgMain').modal('show');
            AtViewModel.copyToAllFlag(0);
            $('#lblThresholdValidation').hide();

            AtViewModel.ClickedRiskAreaId(parseInt(node.id));
            AtViewModel.ClickedRiskFactorName($('<div/>').html(node.text).text());
            AtViewModel.ClickedRAType(node.RA_Type());
            if (AtViewModel.ClickedRiskAreaType() == 'QTDR' && AtViewModel.ClickedRAType() == 'F') {
                GetThresholdData();
                $('#RfTabTh').show();
                $('#QualitativeTabDivTh').hide();
            }
            else {
                $('#QualitativeTabDivTh').show();
                $('#loadingImgMainQualTh').show();
                $('#RfTabTh').hide();
                $('#qualfactordiv').hide();
                $("#saveEditButtons").hide();

                AtViewModel.ClickedRiskAreaName($('<div/>').html(node.text).text());
                AtViewModel.ClickedRiskAreaId(node.id);
                GetQualThresholdData(AtViewModel.ClickedRiskAreaId());
            }
        };

        function jsTreeModel(item) {
            var self = this;

            self.id = item.AreaLevelId.toString();
            self.text = item.AreaLevelName;
            if (AtViewModel.AreaLeveljstree()[self.id].length > 0 && item.DeadNode == 0) {
                self.nodes = $.map(AtViewModel.AreaLeveljstree()[self.id], function (result) {
                    return new jsTreeModel(result);
                });
            }
            self.state = { expanded: false };
            self.dead_node = item.DeadNode;
            self.assessmentTypeList = ko.observableArray(item.AssessmentTypeList);
            self.RA_Type = ko.observable(item.RA_Type);
        }
    }
});
